import { Children, isValidElement, type ReactNode } from "react";

const SCROLLABLE_TABLE_MIN_COLUMN_COUNT = 5;

export type ScoutTableLayoutPlan = {
  columnCount: number;
  shouldScrollHorizontally: boolean;
};

function countColumns(children?: ReactNode): number {
  let columnCount = 0;

  const visit = (node?: ReactNode): void => {
    Children.forEach(node, (child) => {
      if (!isValidElement<{ children?: ReactNode }>(child)) {
        return;
      }

      if (child.type === "tr") {
        let cellsInRow = 0;
        Children.forEach(child.props.children, (cell) => {
          if (isValidElement(cell)) {
            cellsInRow += 1;
          }
        });
        columnCount = Math.max(columnCount, cellsInRow);
        return;
      }

      visit(child.props.children);
    });
  };

  visit(children);
  return columnCount;
}

export function getScoutTableLayoutPlan(children?: ReactNode): ScoutTableLayoutPlan {
  const columnCount = countColumns(children);
  return {
    columnCount,
    shouldScrollHorizontally: columnCount >= SCROLLABLE_TABLE_MIN_COLUMN_COUNT,
  };
}
